<template>
  <div class="">
    <card>
      <form-table-page
        class="index-all-box"
        :data="formData"
        :label="formLabel"
        @Query="Query"
        @Reset="Reset"
      >
        <template slot="input1">
          <el-input v-model="formData.input1" :placeholder="$t('queryForm.pleaseEnter')" />
        </template>

        <template slot="input2">
          <el-input v-model="formData.input2" :placeholder="$t('queryForm.pleaseEnter')" />
        </template>

        <template slot="input3">
          <el-input v-model="formData.input3" :placeholder="$t('queryForm.pleaseEnter')" />
        </template>

      </form-table-page>
    </card>

    <card style="margin-top:10px;">
      <div class="table-content-box">
        <div class="btn-list-box form-btn-list">
          <cus-btn type="add" @click="userAdd()"></cus-btn>
          <cus-btn type="delete" @click="delBtn()" v-if="false"></cus-btn>
          <!-- <el-button type="primary" icon="el-icon-plus" round @click="userAdd">Add</el-button>
          <el-button type="danger" icon="el-icon-delete" round @click="delBtn">Delete</el-button> -->
        </div>

        <table-page
          ref="table"
          :table-data="tableData"
          :search-method="handleSearch"
          :current-page="pageNum"
          :total="total"
          :change-fun="changeTablePage"
          @selectionChange="handleSelectionChange"
        >
          <template slot="tableItem">

            <el-table-column
              prop="tab2"
              :label="$t('administration.key')"
              align="center"
              show-overflow-tooltip
            />

            <el-table-column
              prop="tab3"
              :label="$t('administration.dicValue')"
              align="center"
              show-overflow-tooltip
            />

            <el-table-column
              prop="tab4"
              :label="$t('administration.dicTypeName')"
              align="center"
              show-overflow-tooltip
            />

            <el-table-column
              prop="tab5"
              :label="$t('administration.dicSeq')"
              align="center"
              show-overflow-tooltip
            />

            <el-table-column
              prop="tab1"
              :label="$t('administration.describe')"
              align="center"
              show-overflow-tooltip
            />

            <el-table-column
              class-name="tabAction table-column-action-dropdown"
              prop="tab7"
              :label="$t('formData.action')"
              align="center"
              show-overflow-tooltip
              width="150"
            >
              <template slot-scope="item">
                <el-dropdown @command="constantCustom.commonDropdownCommandHandler">
                  <span class="el-dropdown-link">
                    <!-- {{$t('formData.action')}}<i class="el-icon-arrow-down el-icon--right"></i> -->
                    <i class="el-icon-ali-TechnicalArea"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="{action:seeBtn,param:[item.row.ids]}">{{ $t('button.view') }}</el-dropdown-item>
                    <el-dropdown-item :command="{action:updataBtn,param:[item.row.ids]}">{{ $t('button.edit') }}</el-dropdown-item>
                    <el-dropdown-item v-if="false" :command="{action:deleteBtn,param:[item.row.ids]}">{{ $t("button.delete") }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <!-- <el-link type="primary" :underline="false" @click="seeBtn(item.row.ids)">{{ $t("button.view") }}</el-link>
                <el-link type="primary" :underline="false" @click="updataBtn(item.row.ids)">{{ $t("button.edit") }}</el-link>
                <row-inline-confirm v-if="false"
                  @button-click-event="deleteBtn(item.row.ids)"
                >
                  <el-link type="primary" :underline="false" slot="button">{{ $t("button.delete") }}</el-link>
                </row-inline-confirm> -->
              </template>
            </el-table-column>
          </template>
        </table-page>
      </div>
    </card>
  </div>
</template>

<script>
import { dictInitialize, dictDelete } from '../../api/adminManagement'
export default {

  data() {
    return {
      multipleSelection: [],
      tableData: [],

      pageSize: 10,
      pageNum: 1,
      total: 0,

      formData: {
        input1: '',
        input2: '',
        input3: ''

      },
      formLabel: {
        input1: 'administration.key',
        input2: 'administration.value',
        input3: 'administration.enumerationName'

      }

    }
  },
  computed: {
    lang() {
      return this.$store.state.app.language
    },
    
  },
  watch: {
    lang() {
      this.listMain(this.pageNum, this.$refs.table.pageSize, this.$refs.table.queryData)
    }
  },
  mounted() {
    this.Query()
  },
  methods: {
    /**
     * 查询方法
     * @constructor
     */
    Query(type) {
      this.pageNum = 1
      this.listMain(1, this.$refs.table.pageSize)
    },

    changeTablePage(currentPage, pageSize) {
      this.pageNum = currentPage
      this.$refs.table.pageSize = pageSize
      this.listMain(currentPage, pageSize, this.$refs.table.queryData)
    },

    /**
     * 重置
     * @constructor
     */
    Reset() {
      this.pageNum = 1
      console.log('重置')
    },

    /**
     * 监听分页
     */
    handleSearch(currentPage) {
      // console.log("22222", currentPage);
      this.fetchRemoteData(
        currentPage,
        this.$refs.table.pageSize,
        this.$refs.table.queryData
      )
    },

    userAdd() {
      this.$router.push({
        name: 'dataDictionaryAdd'
      })
    },

    /**
     * table 选中事件
     * @param val
     */
    handleSelectionChange(val) {
      this.multipleSelection = val
      console.log('11111111', this.multipleSelection)
    },

    listMain(currentPage, pageSize, queryData) {
      const self = this
      if (!queryData) {
        queryData = {
          pageNum: currentPage,
          pageSize: pageSize,
          dicKey: self.formData.input1,
          dicValue: self.formData.input2,
          dicTypeName: self.formData.input3
        }
      } else {
        queryData.pageNum = currentPage
        queryData.pageSize = pageSize
      }
      dictInitialize(queryData)
        .then(response => {
          if (response.code === 200) {
            if (response.data && response.data.list) {
              self.tableData = []
              for (let i = 0; i < response.data.list.length; i++) {
                let obj = {}
                obj = {
                  ids: response.data.list[i].id,
                  tab1: response.data.list[i].dicDescription,
                  tab2: response.data.list[i].dicKey,
                  tab3: response.data.list[i].dicValue,
                  tab4: response.data.list[i].dicTypeName,
                  tab5: response.data.list[i].dicSeq
                }
                self.tableData.push(obj)
              }
              this.total = response.data.total
            } else {
              this.tableData = []
              this.total = 0
            }
            // 保存当前查询条件
            this.$refs.table.queryData = queryData
          }
        })
    },

    // 查看
    seeBtn(ids) {
      console.log(ids)
      this.$router.push({ name: 'dataDictionaryAdd', params: { id: ids, type: 1 }})
    },

    //  修改
    updataBtn(ids) {
      this.$router.push({ name: 'dataDictionaryAdd', params: { id: ids, type: 2 }})
    },

    // 删除
    deleteBtn(id) {
      this.$confirm(this.$t("messageCommon.confirmDelete"), this.$t("messageCommon.tips"), {
          confirmButtonText: this.$t("checkList.confirm"),
          cancelButtonText: this.$t("checkList.cancel"),
          type: 'warning'
        }).then(() => {
            const self = this
            const param = {
              ids: [id]
            }
            dictDelete(param)
            .then(response => {
              if (response.code === 200) {
                this.$message({
                  type: 'success',
                  message: response.message
                })
                this.Query()
              }
            })
      }).catch(() => {})
    },

    // 批量删除
    delBtn() {
      // console.log(this.multipleSelection)
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: this.$t("messageCommon.selectAtLeastOne"),
          type: 'warning'
        })
        return
      } else {
        const self = this
        this.$confirm(this.$t("messageCommon.confirmDelete"), this.$t("messageCommon.tips"), {
          confirmButtonText: this.$t("checkList.confirm"),
          cancelButtonText: this.$t("checkList.cancel"),
          type: 'warning'
        }).then(() => {
          const idd = []
          for (let i = 0; i < this.multipleSelection.length; i++) {
            idd[i] = this.multipleSelection[i].ids
          }
          const param = {
            ids: idd
          }
          dictDelete(param)
            .then(response => {
              if (response.code === 200) {
                this.$message({
                  type: 'success',
                  message: response.message
                })
                this.Query()
              }
            })
        }).catch(() => {})
      }
    }

  }
}
</script>

<style scoped lang="scss">

</style>
